import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Box, Button, Card, CardContent, Typography } from "@mui/material"
import { setCheckoutOption } from "src/features/checkout/checkoutSlice"
import {
  DELIVERY_OPTIONS,
  SPECIAL_EVENTS,
  SPECIAL_EVENTS_DATA,
} from "src/app/constants"
import { useLazyGetZipCodeDataQuery } from "src/features/checkout/checkoutApi"
import { LoadingButton } from "@mui/lab"
import { useEffect } from "react"

const specialEvents = [
  // {
  //   key: SPECIAL_EVENTS.ASRC_WAKE_ISLAND,
  //   label: "ASRC - Wake Island",
  //   deliveryOption: DELIVERY_OPTIONS.LOCAL_DELIVERY,
  //   zip: SPECIAL_EVENTS_DATA[SPECIAL_EVENTS.ASRC_WAKE_ISLAND].shippingAddress
  //     .zip,
  // },
  // {
  //   key: SPECIAL_EVENTS.HANALE_ISLAND_SAKE,
  //   label: "Hanale by Island Sake Restaurant Reservation",
  //   deliveryOption: DELIVERY_OPTIONS.LOCAL_DELIVERY,
  //   zip: SPECIAL_EVENTS_DATA[SPECIAL_EVENTS.HANALE_ISLAND_SAKE].shippingAddress
  //     .zip,
  // },
  {
    key: SPECIAL_EVENTS.INSPIRE_YACHT,
    label: "Inspire Yacht Reservation",
    deliveryOption: DELIVERY_OPTIONS.LOCAL_DELIVERY,
    zip: SPECIAL_EVENTS_DATA[SPECIAL_EVENTS.INSPIRE_YACHT].shippingAddress.zip,
  },
]

export default function SpecialEventsCard() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const options = useSelector((state) => state.checkout.options)
  const [getZipData, { data: zipData, isLoading: getZipDataLoading }] =
    useLazyGetZipCodeDataQuery()

  useEffect(() => {
    if (zipData && options.specialEvent) {
      const { deliveryOption, zip } = specialEvents.find(
        (se) => se.key === options.specialEvent,
      )
      dispatch(
        setCheckoutOption({
          deliveryOption: deliveryOption,
          zip: zip,
          zipData,
        }),
      )
    }
  }, [zipData])

  return (
    <Card>
      <CardContent>
        <Typography
          align="center"
          variant="overline"
          fontSize={16}
          fontWeight="700"
          lineHeight={1}
        >
          Special Events
        </Typography>

        <Box marginTop={1}>
          {specialEvents.map((specialEvent) => {
            const { key, label, deliveryOption, zip } = specialEvent

            return (
              <LoadingButton
                key={key}
                loading={key === options?.specialEvent && getZipDataLoading}
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  mt: 1,
                }}
                onClick={async () => {
                  dispatch(
                    setCheckoutOption({
                      specialEvent: key,
                    }),
                  )
                  await getZipData(zip, true)
                  navigate("../information")
                }}
              >
                {label}
              </LoadingButton>
            )
          })}
        </Box>
      </CardContent>
    </Card>
  )
}
